<script lang="ts">
    import { faEdit, faUser } from '@fortawesome/free-solid-svg-icons'
    import type { Purchase } from '../../modules/paymentsApi/purchases/purchase.entity'
    import { GridBadge, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import { PurchaseStatusFriendly } from '../../modules/paymentsApi/purchases/purchase.enum'
    import Zgrid from '../_common/z/zgrid.svelte'
    import { onMount } from 'svelte'
    import Popover from '../_common/popover.svelte'
    import PaymentsPurchaseShow from '../payments/payments-purchase-show.svelte'

    export let personId: string
    let show = false
    let entities: Purchase[] = []

    onMount(async () => {
        await loadEntities()
    })

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'ZanduPay - Cobranças Emitidas'
        grid.subtitle = ''
        grid.fontSize = '13px'
        grid.showFilter = false
        grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.badge }))
        grid.cols.push(new GridCol({ content: 'Descrição', type: GridColTypeEnum.string, maxLength: 45 }))
        grid.cols.push(new GridCol({ content: 'ID', type: GridColTypeEnum.string }))
        grid.cols.push(new GridCol({ content: 'Atraso', type: GridColTypeEnum.int }))
        grid.cols.push(new GridCol({ content: 'Valor', type: GridColTypeEnum.float_2 }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const btnOpen = new GridButton({
                callback: () => showPurchaseDetail(item.purchaseId),
                icon: faEdit,
                label: 'Abrir',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.createdAt })
            line.slots.push({
                content: new GridBadge({
                    label: PurchaseStatusFriendly[item.statusLabel],
                    class: 'status_' + item.status,
                }),
            })
            line.slots.push({ content: item.purchaseDescription })
            line.slots.push({ content: item.purchaseId })
            line.slots.push({ content: item.pastDueDays })
            line.slots.push({ content: item.purchaseTotalValue })
            line.slots.push({ content: [btnOpen] })
            grid.lines.push(line)
        }
    }

    let purchaseId = null
    function showPurchaseDetail(id: string) {
        purchaseId = id
    }

    function closePurchaseShow() {
        purchaseId = null
        loadEntities()
    }

    async function loadEntities() {
        try {
            show = true
            const dt = {
                referenceId: personId,
            }
            entities = await window.api.payments.purchases.getAll(dt)
            entities = await window.api.utils.utils.assignPersonsFromObject(entities, 'referenceId')
            loadGrid()
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }
</script>

{#if purchaseId}
    <Popover title="Cobrança" width="1100px" height="80vh" on:close={closePurchaseShow}>
        <PaymentsPurchaseShow {purchaseId} on:close={closePurchaseShow} />
    </Popover>
{/if}
<Zgrid class="" {grid}></Zgrid>
